export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.21fda7105661b6ef76d390923b77eea2.css";